import axios from 'axios';
import { QAS_SEARCH, QAS_FORMAT, QAS_RESET, GET_ERRORS } from './types';
import { clearErrors } from './utilities';

const qasAPIURL = 'https://api.edq.com/capture/address/v2';

const config = {
	headers: { 'Auth-Token': process.env.GATSBY_QAS_API_TOKEN },
};

var CancelToken = axios.CancelToken; //deprecated
let searchCancel;

//Outdated QAS API Call
export const qasSearch =
	(query, country, take = 4) =>
	(dispatch) => {
		dispatch(clearErrors());
		searchCancel && searchCancel();
		const params = {
			query: query,
			country: country,
			take: take,
		};
		const cancelToken = {
			cancelToken: new CancelToken(function executor(c) {
				searchCancel = c;
			}),
		};
		axios
			.get(`${qasAPIURL}/search`, {
				...config,
				params: params,
				...cancelToken,
			})
			.then((res) => {
				dispatch({
					type: QAS_SEARCH,
					payload: res.data,
				});
			})
			.catch((err) => {
				dispatch({
					type: GET_ERRORS,
					payload: err,
				});
			});
	};

//Outdated QAS API Call
export const qasFormat = (url) => (dispatch) => {
	dispatch(clearErrors());
	axios
		.get(url, config)
		.then((res) => {
			dispatch({
				type: QAS_FORMAT,
				payload: res.data,
			});
		})
		.catch((err) => {
			dispatch({
				type: GET_ERRORS,
				payload: err,
			});
		});
};

const qasAPIURLv2 = 'https://api.experianaperture.io/address/';

// Updated QAS API
export const qasSearchv2 =
	(query, country, suggestions = 4) =>
	(dispatch) => {
		const headers = {
			headers: { 'Auth-Token': process.env.GATSBY_QAS_API_TOKEN },
		};
		dispatch(clearErrors());
		searchCancel && searchCancel();
		const params = {
			country_iso: country,
			max_suggestions: suggestions,
			components: {
				unspecified: [query],
			},
		};
		const cancelToken = {
			cancelToken: new CancelToken(function executor(c) {
				searchCancel = c;
			}),
		};
		axios
			.post(`${qasAPIURLv2}search/v1`, params, headers)
			.then((res) => {
				dispatch({
					type: QAS_SEARCH,
					payload: res.data,
				});
			})
			.catch((err) => {
				dispatch({
					type: GET_ERRORS,
					payload: err,
				});
			});
	};

//Updated QAS API
export const qasFormatv2 = (addressKey) => (dispatch) => {
	const headers = {
		headers: {
			'Auth-Token': process.env.GATSBY_QAS_API_TOKEN,
			'Add-Components': true,
		},
	};
	dispatch(clearErrors());
	axios
		.get(`${qasAPIURLv2}format/v1/${addressKey}`, headers)
		.then((res) => {
			dispatch({
				type: QAS_FORMAT,
				payload: res.data,
			});
		})
		.catch((err) => {
			dispatch({
				type: GET_ERRORS,
				payload: err,
			});
		});
};

export const qasReset = () => ({
	type: QAS_RESET,
});
